import styled from 'styled-components';

import {
  Filters,
  IFiltersProps,
} from 'components/SearchPage/components/Filters/Filters';
import { Button } from 'components/Toolkit/Button/Button';
import { BaseModal } from 'components/Toolkit/Modal/BaseModal';
import { formatNumber } from 'helpers/formatting';
import { StickyFooter } from 'components/Toolkit/StickyFooter/StickyFooter';
import { FiltersPanel } from 'components/SearchPage/components/FiltersPanel/FiltersPanel';
import {
  useSearchFilterDispatch,
  useSearchFilterState,
} from 'components/SearchPage/context/SearchFilterContext';
import { ISearchPageFilter } from 'api/types/searchPageApiTypes';
import { TLastSearch } from 'components/PageWrappers/SharedComponents/LastSearchCard/types';

export interface IFiltersModalProps extends IFiltersProps {
  adCount: number;
  section: string;
  filtersData: ISearchPageFilter[];
  lastSearchData?: TLastSearch;
  lastSearchCallback: () => void;
}

const SBaseModal = styled(BaseModal)`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  max-height: none;
  border-radius: 0;
`;

// spacing added to accommodate the fixed footer
const Body = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.XL72};
`;

function FiltersModal({
  adCount,
  section,
  filtersData,
  lastSearchData,
  lastSearchCallback,
}: IFiltersModalProps) {
  const { isFilterModalOpen } = useSearchFilterState();
  const { setIsFilterModalOpen } = useSearchFilterDispatch();

  const resultOrResults = adCount === 1 ? 'result' : 'results';
  return (
    <SBaseModal
      askToClose={() => setIsFilterModalOpen(false)}
      isOpen={isFilterModalOpen}
      variant="WIDE"
    >
      <FiltersPanel
        lastSearchData={lastSearchData}
        lastSearchCallback={lastSearchCallback}
      >
        <Body>
          <Filters filtersData={filtersData} section={section} />
        </Body>
      </FiltersPanel>
      <StickyFooter data-testid="sticky_footer_results">
        <Button
          onClick={() => {
            window.scroll({ top: 0 });
            setIsFilterModalOpen(false);
          }}
        >
          Show {formatNumber(adCount)} {resultOrResults}
        </Button>
      </StickyFooter>
    </SBaseModal>
  );
}

export { FiltersModal };
